import React, { useState, useEffect } from "react";
import doctor from "../images/doctor-2.png";
import Avtar from "../images/profile.svg";
import { IoMdArrowDropdown } from "react-icons/io";
import { FaBell, FaRegBell } from "react-icons/fa";
import logo from "../images/logoNew.png";
import { RiHome6Line } from "react-icons/ri";
import { LuNotepadText } from "react-icons/lu";
import { IoMdCalendar } from "react-icons/io";
import { RiCalendarCloseLine } from "react-icons/ri";
import { IoHelp, IoSettingsOutline } from "react-icons/io5";
import { LiaHourglassHalfSolid } from "react-icons/lia";
import { LuCalendarCheck } from "react-icons/lu";
import { TiTick } from "react-icons/ti";
import { IoMdSearch } from "react-icons/io";
import { BiLogOut } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import DoctorProfileChart from "./DoctorProfileChart";
import { setDoctorDetails } from "../reduxtool/action";
import { useDispatch, useSelector } from "react-redux";
import PatientProfilePopup from "./PatientProfile";
import { VideoCall } from "@mui/icons-material";
import VideocallMedicationByDoctor from "./VideocallMedicationByDoctor";
import { MdCallMissed } from "react-icons/md";
import { MdCheckCircleOutline } from "react-icons/md";
import { GiHamburgerMenu } from "react-icons/gi";
import AppointmentList from "./AppointmentList";
import PaginationControls from "../CRMDashboard/PaginationControls";
import HomePageDoctorCalender from "./HomePageDoctorCalender";
import { decryptData } from "../Services/TabServices";
import DoctorProfile from "./DoctorProfile";
import ZoomMeeting from "../ZoomMeeting";

interface Appointment {
  appointmentId: string;
  patientName: string;
  doctorName: string;
  specializationName: string;
  formattedDate: string;
  formattedTime: string;
  age: number;
  gender: string;
  appointmentDate: string;
  slotStartTime: string;
  slotEndTime: string;
  email: string;
}

const DoctorDashboard = () => {

  const storedUserId = sessionStorage.getItem("userId");
  const doctorId = storedUserId ? decryptData(storedUserId):null;
  const token = sessionStorage.getItem("token");
  const dispatch: any = useDispatch();
  const doctorDetail = useSelector((state: any) => state.selectedDoctorDetails);
  
    const [isDoctorProfileModalOpen, setIsDoctorProfileModalOpen] = useState(false);

  const [showProfilePopup, setShowProfilePopup] = useState(false);
  const [PaientId, setPatientId] = useState(null);
  const [upcommingFromTodayAppointments, setUpcommingFromTodayAppointments] = useState<any>([]);
  const [upcommingAppointments, setUpcommingAppointments] = useState<any>([]);
  const [pendingAppointments, setPendingAppointment] = useState<any>([]);
  const [cancelledAppointments, setCancelledAppointments] = useState<any>([]);
  const [missedAppointments, setMissedAppointments] = useState<Appointment[]>(
    []
  );
  const [completedAppointments, setCompletedAppointments] = useState<
    Appointment[]
  >([]);
  const [rescheduleAppointments, setRescheduleAppointments] = useState<any>([]);
  const [todayAppointment, setTodayAppointments] = useState<any>([]);
  const [activeAppointments, setActiveAppointment] = useState<any>([]);
  const [scheduleAppointments, setScheduleAppointment] = useState<any>([]);
  const [newPatientTreated, setNewPatientTreated] = useState<string>("");
  const [totalPatientTreated, setTotalPatientTreated] = useState<string>("");
  const [meetLink, setMeetLink] = useState<string | null>(null);
  const [isMeetingStarted, setIsMeetingStarted] = useState(false);
  const [meetSrc, setMeetSrc] = useState(" ");
  const [searchTerm, setSearchTerm] = useState(" ");
  const [activePage, setActivePage] = useState<string>(() => sessionStorage.getItem("activepage")||"Home");
  const [showSidebar, setShowSidebar] = useState(true);
  const [showPopup, setShowPopup] = useState(false);
const [meetingNumber,setMeetingNumber]=useState<string>("");
const [meetingPassword,setMeetingPasswod]=useState<string>("");
const [meetPatientId,setMeetingPatientId]=useState<string>("");
const [meetAppointmentId,setMeetingAppointmentId]=useState<string>("");
  // New state variables for tiles and filters (from CRM Dashboard)
  const [dateRangeFilter, setDateRangeFilter] = useState<'today' | 'week' | 'month' |'custom'|''>('');
  const [customDateRange, setCustomDateRange] = useState<{ from: string, to: string }>({
    from: '',
    to: '',
  });
  const [showDateFilterPopup, setShowDateFilterPopup] = useState(false);
  const [filters, setFilters] = useState({
    speciality: "",
    doctor: "",
    date: "",
    priority: "",
  });
  const [specialities, setSpecialities] = useState([]);
 const isSameDate = (date1: Date, date2: Date) => {
    return date1.toISOString().split("T")[0] === date2.toISOString().split("T")[0];
  };

  const isThisWeek = (date: Date) => {
    const today = new Date();
    const first = new Date(today.setDate(today.getDate() - today.getDay()));
    const last = new Date(first);
    last.setDate(first.getDate() + 6);
    first.setHours(0, 0, 0, 0);
    last.setHours(23, 59, 59, 999);
    return date >= first && date <= last;
  };

  const isThisMonth = (date: Date) => {
    const today = new Date();
    return (
      date.getFullYear() === today.getFullYear() &&
      date.getMonth() === today.getMonth()
    );
  };

  const isInCustomRange = (date: Date, from: string, to: string) => {
    if (!from || !to) return true;
    const start = new Date(from);
    const end = new Date(to);
    start.setHours(0, 0, 0, 0);
    end.setHours(23, 59, 59, 999);
    return date >= start && date <= end;
  };
  // Function to get filtered counts for tiles (from CRM Dashboard)
  const getFilteredCounts = () => {
    const applyFilters = (appointments: any[]) => {
      let filtered = appointments;


      if (searchTerm.trim()) {
        filtered = filtered.filter(
          (item: any) =>
            item.patientName.toLowerCase().includes(searchTerm.toLowerCase()) ||
            item.appointmentId.toString().includes(searchTerm) ||
            item.doctorName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            item.specializationName?.toLowerCase().includes(searchTerm.toLowerCase())
        );
      }

      if (filters.speciality) {
        filtered = filtered.filter((item: any) =>
          item.specializationName
            .toLowerCase()
            .includes(filters.speciality.toLowerCase())
        );
      }

      // Apply date range filter
      if (dateRangeFilter) {
        filtered = filtered.filter((item: any) => {
          let appointmentDate;
            appointmentDate = new Date(`${item.appointmentDate}T${item.slotStartTime}`);
         

          switch (dateRangeFilter) {
            case "today":
              return isSameDate(appointmentDate, new Date());
            case "week":
              return isThisWeek(appointmentDate);
            case "month":
              return isThisMonth(appointmentDate);
            case "custom":
              return isInCustomRange(appointmentDate, customDateRange.from, customDateRange.to);
            default:
              return true;
          }
        });
      }

      return filtered.length;
    };

    return {
      Confirmed: applyFilters(pendingAppointments),
      Scheduled: applyFilters(scheduleAppointments),
      Active: applyFilters(activeAppointments),
      Rescheduled: applyFilters(rescheduleAppointments),
      Completed: applyFilters(completedAppointments),
      Cancelled: applyFilters(cancelledAppointments),
      Missed: applyFilters(missedAppointments),
    };
  };


  // const closePopup = () => {
  //   setShowPopup(false);
  // };


  const getAppointmentsByPage = () => {
    let appointments = [];
    switch (activePage) {
      case "Confirmed":
        appointments = pendingAppointments;
        break;
      case "Upcoming":
        appointments = upcommingAppointments;
        break;
      case "Today":
        appointments = todayAppointment;
        break;
      case "Active":
        appointments = activeAppointments;
        break;
      case "Scheduled":
        appointments = scheduleAppointments;
        break;
      case "Rescheduled":
        appointments = rescheduleAppointments;
        break;
      case "Cancelled":
        appointments = cancelledAppointments;
        break;
      case "Completed":
        appointments = completedAppointments;
        break;
      case "Missed":
        appointments = missedAppointments;
        break;
      default:
        appointments = [];
    }
    // Apply search filter
    if (searchTerm.trim()) {
      appointments = appointments.filter(
        (item: any) =>
          item.patientName.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.appointmentId.toString().includes(searchTerm) ||
          item.doctorName?.toLowerCase().includes(searchTerm) ||
          item.specializationName?.toLowerCase().includes(searchTerm)
      );
    } if (dateRangeFilter) {
      appointments = appointments.filter((item: any) => {
        let appointmentDate;

     
          appointmentDate = new Date(`${item.appointmentDate}T${item.slotStartTime}`);
        

        switch (dateRangeFilter) {
          case "today":
            return isSameDate(appointmentDate, new Date());
          case "week":
            return isThisWeek(appointmentDate);
          case "month":
            return isThisMonth(appointmentDate);
          case "custom":
            return isInCustomRange(appointmentDate, customDateRange.from, customDateRange.to);
          default:
            return true;
        }
      });
    }

    return appointments;
  };
  const [itemsPerPage, setItemsPerPage] = useState(20);

  const [currentPage, setCurrentPage] = useState(1);
  const allAppointments = getAppointmentsByPage();

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentAppointments = allAppointments.slice(
    indexOfFirstItem,
    indexOfLastItem
  );
  const totalPages = Math.ceil(allAppointments.length / itemsPerPage);
const handleMinimize = () => {
    const popup = document.getElementById('video-popup');
    const minimized = document.getElementById('minimized-popup');
    
    if (popup && minimized) {
      // Hide full popup
      popup.style.opacity = '0';
      popup.style.pointerEvents = 'none';
      popup.style.transform = 'scale(0.8)';
      
      // Show minimized view
      setTimeout(() => {
        minimized.style.opacity = '1';
        minimized.style.pointerEvents = 'all';
        minimized.style.transform = 'translateY(0)';
      }, 150);
    }
  };

  const handleMaximize = () => {
    const popup = document.getElementById('video-popup');
    const minimized = document.getElementById('minimized-popup');
    
    if (popup && minimized) {
      // Hide minimized view
      minimized.style.opacity = '0';
      minimized.style.pointerEvents = 'none';
      minimized.style.transform = 'translateY(100%)';
      
      // Show full popup
      setTimeout(() => {
        popup.style.opacity = '1';
        popup.style.pointerEvents = 'all';
        popup.style.transform = 'scale(1)';
      }, 150);
    }
  };

  const closePopup = () => {
    const savedDataKey = `medication-data-${meetPatientId}-${meetAppointmentId}`;
    sessionStorage.removeItem(savedDataKey);
    
    const popup = document.getElementById('video-popup');
    const minimized = document.getElementById('minimized-popup');
    
    if (popup) {
      popup.style.opacity = '1';
      popup.style.pointerEvents = 'all';
      popup.style.transform = 'scale(1)';
    }
    
    if (minimized) {
      minimized.style.opacity = '0';
      minimized.style.pointerEvents = 'none';
      minimized.style.transform = 'translateY(100%)';
    }
    
    setShowPopup(false);
  };
 useEffect(() => {
    setCurrentPage(1);
  }, [activePage, searchTerm, dateRangeFilter, customDateRange]);


  useEffect(() => {
    sessionStorage.setItem("activepage", activePage);
  }, [activePage]);

  const startMeeting = (
    meetUrl: string,
    meetId: string,
    meetPassword: string,
    patientId: string,
    appointmentId: string
  ) => {
    setMeetingNumber(meetId);
    setMeetingPasswod(meetPassword);
    setMeetingPatientId(patientId);
    setMeetingAppointmentId(appointmentId);
    setShowPopup(true);
  };

  // const startMeeting = (meetUrl: string) => {
  //   setShowPopup(true);
  //   const popupWidth = Math.floor(window.innerWidth * 0.6);
  //   const popupHeight = Math.floor(window.innerHeight * 0.99);
  //   const left = 0;
  //   const top = 0;
  //   const bottom = 0;
  //   const popup = window.open(
  //     meetUrl,
  //     "_blank",
  //     `width=${popupWidth},height=${popupHeight},left=${left},top=${top},bottom=${bottom}`
  //   );
  // };


 

  useEffect(() => {
    dispatch(setDoctorDetails(doctorId));
  }, [dispatch]);

  useEffect(() => {
    const fetchPatientTreated = async () => {
      try {
        const response: any = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/Patient/GetAppointmentCompute?doctorId=${doctorId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setTotalPatientTreated(response.data.totalAppointments);
        setNewPatientTreated(response.data.newAppointmentsLast30Days);
      } catch (error) {
        console.error("error in geting totalpatientTreated", error);
      }
    };
    fetchPatientTreated();
  }, []);
  useEffect(() => {
    const fetchDoctorAppointmentList = async () => {
      try {
        const response: any = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/Patient/GetDoctorScheduleAppointment`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
            params: { doctorId: doctorId },
          }
        );
        const doctorAppointment = response.data;
        const now = new Date();
        const updatedAppointments = doctorAppointment.map((item: any) => {
          const dob = new Date(item.dob);
          const age = Math.floor(
            (now.getTime() - dob.getTime()) / (1000 * 60 * 60 * 24 * 365.25)
          );

          const appointmentDateTime = new Date(
            `${item.appointmentDate}T${item.slotStartTime}`
          );

          const formattedDate = appointmentDateTime.toLocaleDateString(
            "en-US",
            {
              day: "2-digit",
              month: "short",
            }
          );

          const formattedTime = appointmentDateTime.toLocaleTimeString(
            "en-US",
            {
              hour: "2-digit",
              minute: "2-digit",
              hour12: true,
            }
          );


          return {
            ...item,
            age,
            formattedDate,
            formattedTime,
          };
        });
        const missedAppointments: any[] = [];
        const categorizedAppointments = updatedAppointments.reduce(
          (acc: any, item: any) => {
            const appointmentDateTime = new Date(
              `${item.appointmentDate}T${item.slotEndTime}`
            );
            const isPast = appointmentDateTime < now;
            const shouldBeMissed =
              isPast &&
              item.flag !== "R" &&
              item.flag !== "C" &&
              item.flag !== "D";

            if (shouldBeMissed) {
              missedAppointments.push(item);
            } else {
              if (item.flag === "A") acc.pending.push(item);
              else if (item.flag === "S") acc.scheduled.push(item);
              else if (item.flag === "R") acc.reschedule.push(item);
              else if (item.flag === "C") acc.cancelled.push(item);
              else if (item.flag === "D") acc.completed.push(item);
            }
            return acc;
          },
          {
            pending: [],
            scheduled: [],
            reschedule: [],
            cancelled: [],
            completed: [],
          }
        );
        const nowTime = new Date();
        const todayDate = nowTime.toISOString().split("T")[0];

        const activeAppointments = updatedAppointments.filter((item: any) => {
          const appointmentStartTime = new Date(
            `${item.appointmentDate}T${item.slotStartTime}`
          );
          const appointmentEndTime = new Date(
            `${item.appointmentDate}T${item.slotEndTime}`
          );
          // const twoHoursAfterEnd = new Date(appointmentEndTime.getTime() + 5 * 60 * 60 * 1000);
          const thirtyMinutesBeforeStart = new Date(
            appointmentStartTime.getTime() - 6 * 60 * 60 * 1000
          );
          const isToday = item.appointmentDate === todayDate;

          return (
            isToday &&
            nowTime >= thirtyMinutesBeforeStart &&
            nowTime <= appointmentEndTime &&
            item.flag === "S" &&
            item.meetLink
          );
        });

        // const now = new Date();
        const currentDate = now.toISOString().split("T")[0];

        const todayAppointments = updatedAppointments
          .filter(
            (item: any) =>
              item.appointmentDate === currentDate && item.flag !== "R"
          )
          .map((item: any) => {
            const appointmentStart = new Date(
              `${item.appointmentDate}T${item.slotStartTime}`
            );
            const appointmentEnd = new Date(
              `${item.appointmentDate}T${item.slotEndTime}`
            );
            const timeDiffInMinutes =
              (appointmentStart.getTime() - now.getTime()) / (1000 * 60);
            const canStartMeeting =
              timeDiffInMinutes <= 30 && now < appointmentEnd;
            return {
              ...item,
              canStartMeeting,
            };
          })
          .sort(
            (a: any, b: any) =>
              new Date(`${a.appointmentDate}T${a.slotStartTime}`).getTime() -
              new Date(`${b.appointmentDate}T${b.slotStartTime}`).getTime()
          );



// const todayDate = now.toISOString().split("T")[0];





        const upcommingAppointments = updatedAppointments
          .filter((item: any) => {
            const appointmentStart = new Date(
              `${item.appointmentDate}T${item.slotStartTime}`
            );

            return (
              appointmentStart > now && (item.flag === "A" || item.flag === "S")
            );
          })
          .sort((a: any, b: any) => {
            return (
              new Date(`${a.appointmentDate}T${a.slotStartTime}`).getTime() -
              new Date(`${b.appointmentDate}T${b.slotStartTime}`).getTime()
            );
          })
          .slice(0, 2);

        const sortByDateTime = (a: any, b: any) =>
          new Date(`${b.appointmentDate}T${b.slotStartTime}`).getTime() -
          new Date(`${a.appointmentDate}T${a.slotStartTime}`).getTime();
        setUpcommingAppointments(upcommingAppointments);

        const upcommingFromTodayAppointment = updatedAppointments
  .filter((item: any) => {
    const appointmentStart = new Date(
      `${item.appointmentDate}T${item.slotStartTime}`
    );

    return (
      item.appointmentDate >= todayDate &&
      (item.flag === "A" || item.flag === "S")
    );
  })
  .sort((a: any, b: any) => {
    return (
      new Date(`${a.appointmentDate}T${a.slotStartTime}`).getTime() -
      new Date(`${b.appointmentDate}T${b.slotStartTime}`).getTime()
    );
  })
 
setUpcommingFromTodayAppointments(upcommingFromTodayAppointment)
        setTodayAppointments(todayAppointments);
        setCancelledAppointments(
          categorizedAppointments.cancelled.sort(sortByDateTime)
        );
        setPendingAppointment(
          categorizedAppointments.pending.sort(sortByDateTime)
        );
        setActiveAppointment(activeAppointments.sort(sortByDateTime));
        setScheduleAppointment(
          categorizedAppointments.scheduled.sort(sortByDateTime)
        );
        setRescheduleAppointments(
          categorizedAppointments.reschedule.sort(sortByDateTime)
        );
        setMissedAppointments(missedAppointments.sort(sortByDateTime));
        setCompletedAppointments(
          categorizedAppointments.completed.sort(sortByDateTime)
        );
      } catch (error) {
        console.error("error in soctor appointment list", error);
      }
    };
    fetchDoctorAppointmentList();
  }, [activePage]);

  const navigate = useNavigate();
  const handleLogout = () => {
    sessionStorage.removeItem("activepage");
    sessionStorage.removeItem("userType");
    sessionStorage.removeItem("userId");
    sessionStorage.removeItem("token");
    navigate("/doctorLogin");
  };
  return (
    <div className="bg-[#F5F5F5]">
       {isDoctorProfileModalOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50"
          onClick={() => setIsDoctorProfileModalOpen(false)} 
        >
          <div
            className="bg-white rounded-md shadow-md p-6 max-w-sm w-full"
            onClick={(e) => e.stopPropagation()} 
          >
       <DoctorProfile
              doctorDetail={doctorDetail[0]}
              onClose={() => setIsDoctorProfileModalOpen(false)} 
            />  
              </div>
        </div>
      )}
     {showPopup && (
        <>
          <div 
            id="video-popup" 
            className="fixed inset-0 bg-black bg-opacity-10 flex flex-row z-[9999] transition-all duration-300"
            style={{ 
              opacity: 1, 
              pointerEvents: 'all', 
              transform: 'scale(1)' 
            }}
          >
            {/* Zoom SDK container */}
            <div className="flex-1 h-full relative">
              <ZoomMeeting
                meetingNumber={meetingNumber}
                meetingPassword={meetingPassword}
                userName={doctorDetail[0]?.doctorName}
                role={1}
              />
              
              {/* Minimize Button - Top Left */}
              <button
                onClick={handleMinimize}
                className="absolute top-1 -right-10 bg-black bg-opacity-50 hover:bg-opacity-70 text-white p-1 rounded-full shadow-lg transition-all duration-200 z-10 group"
                title="Minimize Meeting"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M20 12H4" />
                </svg>
                <span className="absolute left-full ml-2 top-1/2 transform -translate-y-1/2 bg-black text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
                  Minimize
                </span>
              </button>
            </div>

            {/* Right side panel for doctor medication */}
            <div className="relative bg-white rounded-xl w-[60%] md:w-[60%] lg:w-[40%] text-black h-full shadow-lg">
              {/* Close button for the panel */}
              
              
              <VideocallMedicationByDoctor
                closePopup={closePopup}
                patientId={meetPatientId}
                appointmentId={meetAppointmentId}
                key={`${meetPatientId}-${meetAppointmentId}`}
              />
            </div>
          </div>

          {/* Minimized View - Hidden by default */}
          <div 
            id="minimized-popup" 
            className="fixed bottom-4 right-4 z-[9999] transition-all duration-300"
            style={{ 
              opacity: 0, 
              pointerEvents: 'none', 
              transform: 'translateY(100%)' 
            }}
          >
            <div className="bg-gradient-to-r from-[#184A84] to-[#1a5294] text-white rounded-2xl shadow-2xl border-2 border-white min-w-[320px] max-w-[400px]">
              {/* Header */}
              <div className="p-4 border-b border-white/10">
                <div className="flex items-center justify-between mb-2">
                  <div className="flex items-center space-x-3">
                    <div className="w-3 h-3 bg-green-400 rounded-full animate-pulse"></div>
                    <span className="font-semibold text-sm">Meeting Active</span>
                  </div>
                  
                  <div className="flex items-center space-x-2">
                    {/* Resume Button */}
                    <button
                      onClick={handleMaximize}
                      className="bg-white bg-opacity-20 hover:bg-opacity-30 p-2 rounded-lg transition-all duration-200"
                      title="Resume Meeting"
                    >
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4" />
                      </svg>
                    </button>
                    
                    {/* End Meeting Button */}
                    {/* <button
                      onClick={closePopup}
                      className="bg-red-500 hover:bg-red-600 p-2 rounded-lg transition-all duration-200"
                      title="End Meeting"
                    >
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    </button> */}
                  </div>
                </div>
                
                <div className="text-sm text-white/90">
                  <p className="font-medium truncate">{doctorDetail[0]?.doctorName}</p>
                  <p className="text-xs text-white/70">Meeting: {meetingNumber}</p>
                </div>
              </div>
              
              {/* Meeting Info */}
              <div className="p-4">
                <div className="flex items-center justify-between text-sm mb-3">
                  <div className="flex items-center space-x-2">
                    <svg className="w-4 h-4 text-white/80" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                    </svg>
                    <span className="text-white/90">Patient ID:</span>
                  </div>
                  <span className="font-mono bg-white/20 px-2 py-1 rounded text-xs">
                    {meetPatientId}
                  </span>
                </div>
                
                <div className="flex items-center justify-between text-sm mb-4">
                  <div className="flex items-center space-x-2">
                    <svg className="w-4 h-4 text-white/80" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                    <span className="text-white/90">Appointment:</span>
                  </div>
                  <span className="font-mono bg-white/20 px-2 py-1 rounded text-xs">
                    {meetAppointmentId}
                  </span>
                </div>
                
                {/* Action Buttons */}
                <div className="flex gap-2">
                  <button
                    onClick={handleMaximize}
                    className="flex-1 bg-white text-[#184A84] px-4 py-2 rounded-lg font-semibold hover:bg-white/90 transition-all duration-200 text-sm"
                  >
                    Resume
                  </button>
                  <button
                    onClick={() => {
                      handleMaximize();
                      // Focus on medication panel after resuming
                      setTimeout(() => {
                        const medicationPanel = document.querySelector('[data-medication-panel]');
                        if (medicationPanel) {
                          medicationPanel.scrollIntoView({ behavior: 'smooth' });
                        }
                      }, 300);
                    }}
                    className="flex-1 bg-white/20 hover:bg-white/30 text-white px-4 py-2 rounded-lg font-semibold transition-all duration-200 text-sm"
                  >
                    Medication
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {/* topBar */}
      <div className="sticky top-0 shadow-sm z-50">
        <div className="flex justify-between items-center w-full h-[45px] bg-white px-2 xs:px-5 ">
          <div className="flex  gap-3 xs:gap-5">
            <div
              className="p-1 xs:p-2 rounded-full  flex items-center justify-center cursor-pointer "
              onClick={() => setShowSidebar(!showSidebar)}
            >
              <GiHamburgerMenu className="text-[#184A84] text-lg w-4 h-4 " />
            </div>
            <div className="flex items-center gap-5 flex-shrink-0">
              <a
                href="https://www.ramahospital.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={logo}
                  alt="Rama Hospital Logo"
                  className="h-[25px] w-[100px]"
                />
              </a>
            </div>
          </div>

          <div className="flex-grow min-w-[200px] max-w-lg px-5">
            <div className="relative w-full">
              {/* Search Input Container */}
              <input
                type="text"
                className="w-full px-2 shadow-sm bg-[#F5F5F5]  py-1 xs:py-1 rounded-full focus:outline-none focus:ring-1 focus:ring-[#009A85] text-[14px]"
                placeholder="Search ... "
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              {/* Search Icon */}
              <span className=" absolute top-1/2 transform -translate-y-1/2 right-1 text-[#184A84] rounded-full p-2 cursor-pointer ">
                <IoMdSearch />
              </span>
            </div>
          </div>
          {/* <div className="flex justify-around gap-4">
            <div className="p-1 rounded-full bg-[#F5F7FA] flex items-center justify-center hidden sm:inline ">
              <IoSettingsOutline className="text-[#184A84] text-lg" />
            </div>
            <div className="p-1 rounded-full bg-[#F5F7FA] flex items-center justify-center">
              <FaRegBell className="text-[#184A84] text-lg" />
            </div>
          </div> */}
        </div>
      </div>

      <div className=" flex gap-5 w-[100%] relative">
        {showSidebar && window.innerWidth < 1024 && (
          <div
            className="fixed inset-0 bg-white bg-opacity-10 z-20"
            onClick={() => setShowSidebar(false)}
          />
        )}
        {showSidebar && (
          <div
            className={`
          bg-white p-2 shadow-md z-30
          min-w-[250px]
          fixed lg:relative top-[40px] left-0 h-[calc(100vh-45px)]
          lg:sticky lg:top-[45px]
        `}
          >
            {[
              { name: "Home", icon: <RiHome6Line className="text-lg" /> },
              { name: "Active", icon: <LuNotepadText className=" text-lg" /> },
              {
                name: "Scheduled",
                icon: <LuCalendarCheck className=" text-lg" />,
              },
              {
                name: "Confirmed",
                icon: <LiaHourglassHalfSolid className=" text-lg" />,
              },
              {
                name: "Rescheduled",
                icon: <IoMdCalendar className=" text-lg" />,
              },
              {
                name: "Cancelled",
                icon: <RiCalendarCloseLine className=" text-lg" />,
              },
              {
                name: "Missed",
                icon: <MdCallMissed className=" text-lg" />,
              },
              {
                name: "Completed",
                icon: <MdCheckCircleOutline className=" text-lg" />,
              },
            ].map((item) => (
              <div
                key={item.name}
                onClick={() => {
                  setActivePage(item.name);
                  if (window.innerWidth < 1024) setShowSidebar(false);
                }}
                className={`flex items-center gap-4 pl-6 p-3 hover:bg-blue-50 rounded-md cursor-pointer  ${
                  activePage === item.name
                    ? "bg-blue-100 text-[#4A90E2]"
                    : "text-[#606060]"
                }`}
              >
                <p
                  className={`${
                    activePage === item.name
                      ? "text-[#4A90E2]"
                      : "text-[#606060]"
                  }`}
                >
                  {item.icon}
                </p>
                <span className={` font-medium text-[14px] `}>{item.name}</span>
              </div>
            ))}
            <div className="w-[190px] absolute bottom-5 pl-1">
              {/* User Info */}

              <div className="flex items-center gap-2 pb-2 cursor-pointer"onClick={() => setIsDoctorProfileModalOpen(true)} >
                {doctorDetail[0]?.doctorImage?(
                  <img
                    src={`${process.env.REACT_APP_BASE_URL}/${doctorDetail[0]?.doctorImage}`}
                    alt="User Avatar"
                    className="w-8 h-8 rounded-full"
                  />
                ) : (
                  <img
                    src={Avtar}
                    alt="Patient"
                    className="w-7 h-7 rounded-full "
                  />
                )}
                {/* 
        <img
           src={`${process.env.REACT_APP_BASE_URL}/${doctorDetail[0]?.doctorImage}`} 
          alt="User Avatar"
          className="w-8 h-8 rounded-full"
        /> */}

                <div className="w-[160px] overflow-hidden">
                  <h4 className="font-semibold text-black text-sm truncate w-full overflow-hidden">
                    {doctorDetail[0]?.doctorName}
                  </h4>
                  <p className="text-xs text-gray-500 truncate ">
                    {doctorDetail[0]?.emailId}
                  </p>
                </div>
              </div>
              {/* Logout  Button */}
              <div
                onClick={handleLogout}
                className="group flex items-center justify-center gap-2 w-full p-2 border border-[#184A84] rounded-md cursor-pointer hover:bg-[#184A84] transition"
              >
                <BiLogOut className="text-[#184A84] text-lg group-hover:text-white" />
                <span className="font-medium text-[14px] text-[#184A84] group-hover:text-white">
                  Logout
                </span>
              </div>
            </div>
          </div>
        )}
        {/* dynamic page  */}
        <div className="w-full">
          
          {/* popup patient profile medical information  */}
             {showProfilePopup && (
            <PatientProfilePopup
              patientId={PaientId}
              onClose={() => setShowProfilePopup(false)}
            />
          )}

          {/* Tiles Section - Only show for non-Home pages */}
      
            <div
              className={`bg-white
                fixed top-[45px] z-20  rounded-xl
                 px-2 py-2 flex justify-between items-center 
                ${showSidebar ? "lg:w-[calc(100%-265px)] w-full" : "w-full "}
              `}
            >
              {/* Enhanced Status Tabs - Scrollable on All Screens */}
              <div className="overflow-x-auto whitespace-nowrap scrollbar-hide flex-1 custom- mr-2 custom-scrollbar">
                <div className="flex gap-1.5 sm:gap-3 min-w-max ">
                  {(() => {
                    const filteredCounts = getFilteredCounts();
                    const hasActiveFilters = searchTerm.trim() || filters.speciality || dateRangeFilter;

                    return [
                      { name: "Confirmed", count: hasActiveFilters ? filteredCounts.Confirmed : pendingAppointments.length, color: "bg-amber-500", border: "border-amber-500", hoverColor: "hover:bg-amber-600" },
                      { name: "Scheduled", count: hasActiveFilters ? filteredCounts.Scheduled : scheduleAppointments.length, color: "bg-blue-500", border: "border-blue-500", hoverColor: "hover:bg-blue-600" },
                      { name: "Active", count: hasActiveFilters ? filteredCounts.Active : activeAppointments.length, color: "bg-green-500", border: "border-green-500", hoverColor: "hover:bg-green-600" },
                      { name: "Rescheduled", count: hasActiveFilters ? filteredCounts.Rescheduled : rescheduleAppointments.length, color: "bg-purple-500", border: "border-purple-500", hoverColor: "hover:bg-purple-600" },
                      { name: "Completed", count: hasActiveFilters ? filteredCounts.Completed : completedAppointments.length, color: "bg-emerald-500", border: "border-emerald-500", hoverColor: "hover:bg-emerald-600" },
                      { name: "Cancelled", count: hasActiveFilters ? filteredCounts.Cancelled : cancelledAppointments.length, color: "bg-red-500", border: "border-red-500", hoverColor: "hover:bg-red-600" },
                      { name: "Missed", count: hasActiveFilters ? filteredCounts.Missed : missedAppointments.length, color: "bg-orange-500", border: "border-orange-500", hoverColor: "hover:bg-gray-600" },
                    ].map((item) => {
                      const isActive = activePage === item.name;

                      return (
                        <div
                          key={item.name}
                          onClick={() => setActivePage(item.name)}
                          className={`
                            cursor-pointer px-2 sm:px-2 py-2 rounded-lg flex items-center gap-2 min-w-fit 
                            relative group
                            ${isActive 
                              ? `bg-white text-[#184A84] shadow-md border-2 ${item.border} font-bold` 
                              : "bg-white/90 hover:bg-white text-gray-700 border-2 hover:text-gray-900 shadow-sm"
                            }
                          `}
                        >
                          {/* Count Badge */}
                          <div className={`
                            w-6 h-6 sm:w-7 sm:h-7 rounded-full flex items-center justify-center text-white font-bold text-xs sm:text-sm
                            ${isActive ? item.color : item.color}
                            shadow-sm
                          `}>
                            {item.count}
                          </div>

                          {/* Status Name */}
                          <span className={`
                            text-xs sm:text-sm font-medium
                            ${isActive ? "text-[#184A84]" : "text-gray-700"}
                          `}>
                            <span className="hidden sm:inline">{item.name}</span>
                            <span className="sm:hidden">{item.name.slice(0, 4)}</span>
                          </span>

                          {/* Hover Effect */}
                          <div className="absolute inset-0 rounded-lg bg-gradient-to-r from-transparent to-white/10 opacity-0 group-hover:opacity-100 transition-opacity duration-200"></div>
                        </div>
                      );
                    });
                  })()}
                </div>
              </div>

              {/* Enhanced Date Filter Button for All Devices */}
              <div className="flex items-center gap-1 sm:gap-2">
                <button
                  onClick={() => setShowDateFilterPopup(true)}
                  className={`flex items-center gap-1 sm:gap-2 px-2 sm:px-3 py-1.5 rounded-md transition-all duration-200 text-xs sm:text-sm ${
                    dateRangeFilter 
                      ? "bg-white text-[#184A84] shadow border border-[#184A84] font-medium" 
                      : "bg-white/20 hover:bg-white/30 text-black"
                  }`}
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v14a2 2 0 002 2z" />
                  </svg>
                  <span className="hidden sm:inline font-medium">
                    {dateRangeFilter 
                      ? (dateRangeFilter === 'custom' 
                        ? 'Custom Range' 
                        : dateRangeFilter.charAt(0).toUpperCase() + dateRangeFilter.slice(1)
                      ) 
                      : 'Date Filter'
                    }
                  </span>
                  <span className="sm:hidden font-medium">
                    {dateRangeFilter ? 'Date' : 'Filter'}
                  </span>
                  {dateRangeFilter && <span className="w-1.5 h-1.5 bg-orange-400 rounded-full"></span>}
                </button>

                {/* Clear Filters Button */}
                {(searchTerm.trim() || filters.speciality || dateRangeFilter) && (
                  <button
                    onClick={() => {
                      setSearchTerm('');
                      setFilters({ speciality: "", doctor: "", date: "", priority: "" });
                      setDateRangeFilter('');
                      setCustomDateRange({ from: '', to: '' });
                    }}
                    className="bg-red-500 hover:bg-red-600 text-white px-2 sm:px-3 py-1.5 rounded-md text-xs sm:text-sm font-medium shadow-sm transition-colors"
                  >
                    <span className="hidden sm:inline">Clear All</span>
                    <span className="sm:hidden">Clear</span>
                  </button>
                )}
              </div>
            </div>
         

          {/* Universal Date Filter Popup */}
          {showDateFilterPopup && (
            <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
              <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md animate-scale-up overflow-hidden" onClick={(e) => e.stopPropagation()}>
                {/* Header */}
                <div className="flex justify-between items-center px-3 py-2 border-b border-gray-200">
                  <div className="flex items-center gap-2">
                    <div className="w-9 h-9 bg-[#184A84] rounded-full flex items-center justify-center">
                      <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v14a2 2 0 002 2z" />
                      </svg>
                    </div>
                    <div>
                      <h3 className="text-base font-bold text-gray-900">Date Filter</h3>
                      <p className="text-xs text-gray-500">Filter by date range</p>
                    </div>
                  </div>
                  <button
                    onClick={() => setShowDateFilterPopup(false)}
                    className="p-1.5 hover:bg-gray-100 rounded-full transition-colors"
                  >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                </div>

                {/* Content */}
                <div className="px-3 py-3 space-y-3">
                  {/* Quick Options */}
                  <div>
                    <h4 className="text-xs font-semibold text-gray-700 mb-1">Quick Options</h4>
                    <div className="grid grid-cols-2 gap-2">
                      {[
                        { value: '', label: 'All Dates' },
                        { value: 'today', label: 'Today' },
                        { value: 'week', label: 'This Week' },
                        { value: 'month', label: 'This Month' },
                      ].map((option) => (
                        <button
                          key={option.value}
                          onClick={() => {
                            setDateRangeFilter(option.value as any);
                            if (option.value !== 'custom') {
                              setCustomDateRange({ from: '', to: '' });
                            }
                          }}
                          className={`p-2 rounded-lg text-left border text-sm font-medium transition-all duration-200 ${
                            dateRangeFilter === option.value 
                              ? "bg-[#184A84] text-white border-[#184A84] shadow-md" 
                              : "bg-gray-50 hover:bg-gray-100 border-gray-200"
                          }`}
                        >
                          {option.label}
                        </button>
                      ))}
                    </div>
                  </div>

                  {/* Custom Range */}
                  <div className="border-t border-gray-200 pt-3">
                    <button
                      onClick={() => setDateRangeFilter('custom')}
                      className={`w-full p-2 rounded-lg text-left border transition-all duration-200 text-sm font-medium ${
                        dateRangeFilter === 'custom'
                          ? "bg-[#184A84] text-white border-[#184A84] shadow-md"
                          : "bg-gray-50 hover:bg-gray-100 border-gray-200"
                      }`}
                    >
                      Custom Range
                    </button>

                    {dateRangeFilter === 'custom' && (
                      <div className="mt-3 bg-gray-50 p-3 rounded-lg border border-gray-200 space-y-2">
                        <h5 className="text-xs font-semibold text-gray-700">Select Date Range</h5>
                        <div className="grid gap-2">
                          <div>
                            <label className="block text-xs font-medium text-gray-600 mb-1">From</label>
                            <input
                              type="date"
                              value={customDateRange.from}
                              onChange={(e) => setCustomDateRange(prev => ({ ...prev, from: e.target.value }))}
                              className="w-full p-2 border border-gray-300 rounded text-sm focus:ring-2 focus:ring-[#184A84] focus:border-[#184A84] focus:outline-none"
                            />
                          </div>
                          <div>
                            <label className="block text-xs font-medium text-gray-600 mb-1">To</label>
                            <input
                              type="date"
                              value={customDateRange.to}
                              onChange={(e) => setCustomDateRange(prev => ({ ...prev, to: e.target.value }))}
                              className="w-full p-2 border border-gray-300 rounded text-sm focus:ring-2 focus:ring-[#184A84] focus:border-[#184A84] focus:outline-none"
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {/* Footer */}
                <div className="flex gap-2 px-3 py-2 border-t border-gray-200">
                  <button
                    onClick={() => {
                      setDateRangeFilter('');
                      setCustomDateRange({ from: '', to: '' });
                    }}
                    className="flex-1 bg-gray-100 hover:bg-gray-200 text-gray-700 py-2 rounded-lg text-sm font-medium transition-colors"
                  >
                    Reset
                  </button>
                  <button
                    onClick={() => setShowDateFilterPopup(false)}
                    className="flex-1 bg-[#184A84] hover:bg-[#0f3a6b] text-white py-2 rounded-lg text-sm font-medium transition-colors"
                  >
                    Apply
                  </button>
                </div>
              </div>
            </div>
          )}

          {activePage === "Home" && (
            <div className=" w-full mt-12">
              {/* top analytics */}
             {/* <div className="w-full space-y-6 p-4">
  <div className="w-full space-y-6 p-4 lg:p-2 lg:space-y-4">
  <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-2">
   
    <div className="lg:col-span-1 bg-gradient-to-br from-[#184A84]/50 to-[#184A84]/30 rounded-2xl p-6 lg:p-4 shadow-lg hover:shadow-xl transition-all duration-300">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2 gap-4 lg:gap-3 h-full">
     
        <div className="bg-white rounded-xl p-6 lg:p-4 shadow-sm hover:shadow-md transition-shadow duration-200 flex flex-col justify-center">
          <div className="text-center">
            <p className="text-sm font-semibold text-[#184A84] mb-3 lg:mb-2">
              Today's Appointments
            </p>
            <div className="relative">
              <p className="text-4xl lg:text-3xl font-bold text-[#184A84] drop-shadow-lg">
                {todayAppointment.length}
              </p>
              <div className="absolute -inset-1 bg-[#184A84]/10 rounded-full blur-xl -z-10"></div>
            </div>
            <div className="mt-3 lg:mt-2 flex items-center justify-center gap-2">
              <div className="w-2 h-2 bg-[#184A84] rounded-full animate-pulse"></div>
              <span className="text-xs text-[#184A84] font-medium">Live Updates</span>
            </div>
          </div>
        </div>

    
        <div className="bg-white rounded-xl p-4 lg:p-3 shadow-sm hover:shadow-md transition-shadow duration-200 flex flex-col">
          <p className="text-sm font-semibold text-[#184A84] mb-3 lg:mb-2 text-center">
            Upcoming Appointments
          </p>
          <div className="flex-1 space-y-2 lg:space-y-1 max-h-48 lg:max-h-20 overflow-y-auto custom-scrollbar">
            {upcommingAppointments.slice(0, 3).map((appt: any, index: number) => (
              <div
                key={appt.id || index}
                className="group bg-gradient-to-r from-[#184A84]/10 to-[#184A84]/5 rounded-lg p-3 lg:p-2 hover:from-[#184A84]/20 hover:to-[#184A84]/10 transition-all duration-200 border border-[#184A84]/20"
              >
                <div className="flex items-center justify-between text-xs">
                  <div className="flex items-center gap-2 flex-1 min-w-0">
                    <div className="min-w-0 flex-1">
                      <p className="font-semibold text-gray-800 truncate text-xs lg:text-[10px] w-fit">
                        {appt.patientName}
                      </p>
                      <p className="text-gray-600 text-xs lg:text-[10px] w-fit">
                        {appt.formattedDate}
                      </p>
                    </div>
                  </div>
                  <div className="flex items-center gap-2 lg:gap-1">
                    <span className="text-xs lg:text-[10px] text-gray-700 font-medium">
                      {appt.formattedTime}
                    </span>
                    <div className="text-[#184A84] text-sm lg:text-xs">
                      {appt.flag === "A" ? (
                        <LiaHourglassHalfSolid className="w-4 h-4 lg:w-3 lg:h-3" />
                      ) : appt.flag === "S" ? (
                        <TiTick className="w-4 h-4 lg:w-3 lg:h-3" />
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            ))}
            {upcommingAppointments.length === 0 && (
              <div className="flex flex-col items-center justify-center py-8 lg:py-6">
                
               <p className="text-xs lg:text-[10px] text-gray-500 mt-1">No upcoming appointments</p>
              </div>
            )}
          </div>
          {upcommingAppointments.length > 3 && (
            <div className="mt-3 lg:mt-2 pt-3 lg:pt-2 border-t border-[#184A84]/20">
              <p className="text-center text-xs lg:text-[10px] text-[#184A84] font-semibold hover:text-[#0f3a6b] cursor-pointer transition-colors">
                +{upcommingAppointments.length - 3} More Appointments
              </p>
            </div>
          )}
        </div>
      </div>
    </div>

  
    <div className="lg:col-span-1 bg-gradient-to-br from-[#009A85]/50 to-[#009A85]/30 rounded-2xl p-6 lg:p-4 shadow-lg hover:shadow-xl transition-all duration-300">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2 gap-4 lg:gap-3 h-full">
     
        <div className="bg-white rounded-xl p-6 lg:p-4 shadow-sm hover:shadow-md transition-shadow duration-200 flex flex-col justify-center">
          <div className="text-center">
            <p className="text-sm font-semibold text-[#009A85] mb-2 lg:mb-1">
              Total Patients
            </p>
            <div className="relative">
              <p className="text-4xl lg:text-3xl font-bold text-[#009A85] drop-shadow-lg mb-2 lg:mb-1">
                {totalPatientTreated}
              </p>
              <div className="absolute -inset-2 bg-[#009A85]/10 rounded-full blur-xl -z-10"></div>
            </div>
            <div className="inline-flex items-center px-3 py-1 lg:px-2 lg:py-0.5 rounded-full bg-[#009A85]/10 border border-[#009A85]/20">
              <span className="text-xs lg:text-[10px] font-semibold text-[#009A85]">All Time</span>
            </div>
          </div>
        </div>

      
        <div className="bg-white rounded-xl p-6 lg:p-4 shadow-sm hover:shadow-md transition-shadow duration-200 flex flex-col justify-center">
          <div className="text-center">
            <p className="text-sm font-semibold text-[#009A85] mb-2 lg:mb-1">
              New Patients This Month
            </p>
            <div className="relative">
              <p className="text-4xl lg:text-3xl font-bold text-[#009A85] drop-shadow-lg mb-2 lg:mb-1">
                {newPatientTreated}
              </p>
              <div className="absolute -inset-2 bg-[#009A85]/10 rounded-full blur-xl -z-10"></div>
            </div>
            <div className="flex items-center justify-center gap-2 lg:gap-1">
              <div className="w-2 h-2 lg:w-1.5 lg:h-1.5 bg-green-500 rounded-full"></div>
              <span className="text-xs lg:text-[10px] font-semibold text-[#009A85]">This Month</span>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div className="lg:col-span-1 bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden">
      <div className="bg-gradient-to-r from-gray-50 to-gray-100 p-6 lg:p-4">
        <div className="text-center">
          <p className="text-sm font-semibold text-[#184A84] mb-4 lg:mb-3">
            Quick Stats
          </p>
          
          <div className="space-y-4 lg:space-y-3">
        
            <div className="bg-white rounded-xl p-4 lg:p-3 shadow-sm hover:shadow-md transition-all duration-200 group cursor-pointer"
                 onClick={() => setActivePage("Confirmed")}>
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3 lg:gap-2">
                  <div className="w-10 h-10 lg:w-8 lg:h-8 bg-red-100 rounded-full flex items-center justify-center group-hover:bg-red-200 transition-colors">
                    <svg className="w-5 h-5 lg:w-4 lg:h-4 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  <div className="text-left">
                    <p className="text-sm lg:text-xs font-semibold text-gray-800">
                      Confirmed Follow-Ups
                    </p>
                    <p className="text-xs lg:text-[10px] text-gray-500">
                      Requires attention
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-2 lg:gap-1">
                  <span className="bg-[#FF0000] text-white px-3 py-1 lg:px-2 lg:py-0.5 rounded-full text-sm lg:text-xs font-bold min-w-[2rem] lg:min-w-[1.5rem] text-center group-hover:scale-110 transition-transform">
                    {pendingAppointments?.length || 0}
                  </span>
                  <svg className="w-4 h-4 lg:w-3 lg:h-3 text-gray-400 group-hover:text-gray-600 transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </div>
              </div>
            </div>

         
            <div className="bg-white rounded-xl p-4 lg:p-3 shadow-sm hover:shadow-md transition-all duration-200 group cursor-pointer"
                 onClick={() => setActivePage("Active")}>
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3 lg:gap-2">
                  <div className="w-10 h-10 lg:w-8 lg:h-8 bg-green-100 rounded-full flex items-center justify-center group-hover:bg-green-200 transition-colors">
                    <svg className="w-5 h-5 lg:w-4 lg:h-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 002 2v8a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <div className="text-left">
                    <p className="text-sm lg:text-xs font-semibold text-gray-800">
                      Active Cases
                    </p>
                    <p className="text-xs lg:text-[10px] text-gray-500">
                      Ready for consultation
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-2 lg:gap-1">
                  <span className="bg-[#FF0000] text-white px-3 py-1 lg:px-2 lg:py-0.5 rounded-full text-sm lg:text-xs font-bold min-w-[2rem] lg:min-w-[1.5rem] text-center group-hover:scale-110 transition-transform">
                    {activeAppointments?.length || 0}
                  </span>
                  <svg className="w-4 h-4 lg:w-3 lg:h-3 text-gray-400 group-hover:text-gray-600 transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </div>
              </div>
            </div>
          </div>

       
          <div className="mt-6 lg:mt-4 pt-4 lg:pt-3 border-t border-gray-200">
            <div className="flex items-center justify-center gap-2 lg:gap-1 text-gray-500 hover:text-[#184A84] cursor-pointer transition-colors group">
              <span className="text-xs lg:text-[10px] font-semibold">View More Details</span>
              <svg className="w-4 h-4 lg:w-3 lg:h-3 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div> */}


              {/* bottom analytics + chart */}
              <div className="flex flex-col sm:flex-row justify-between gap-4 w-full pt-6">
                {/* today's Appointment Div */}
                <div
                  className="gap-5 px-4  bg-white rounded-lg w-full sm:w-3/5 overflow-y-auto"
                  style={{ height: "calc(100vh - 280px)" }}
                >
                  <p className=" sticky top-0 flex justify-center text-[20px] text-[#606060] font-semibold mb-2 bg-white py-2">
                    Today’s Appointments
                  </p>
                  {todayAppointment.length === 0 ? (
                    <div
                      className="flex flex-col items-center justify-center  text-lg py-10"
                      style={{ height: "calc(100vh - 370px)" }}
                    >
                      <p className="text-[18px] font-medium">
                        No appointments scheduled for today.
                      </p>
                    </div>
                  ) : (
                    <>
                      {todayAppointment.map((appointment: any, index: any) => (
                        <div className="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-3 gap-5 bg-[#F5F5F5] px-5 py-2 rounded mb-1">
                          {/* Left Section*/}
                          <div>
                            <p className="font-bold">
                              {appointment.patientName}
                            </p>
                            <p className="text-[12px] mt-2">
                              appId:{appointment.appointmentId}
                            </p>
                          </div>
                          {/* Middle Section*/}
                          <div>
                            {/* <p className="text-[14px]">Video Consultation</p> */}
                          <button
  className={`px-2 text-[12px] rounded-lg mt-1 ${
    appointment.flag === "A"
      ? "bg-[#FFF8E1] text-[#F57C00] border border-[#F57C00]" // Confirmed - Amber/Orange
      : appointment.flag === "S"
      ? "bg-[#E3F2FD] text-[#1976D2] border border-[#1976D2]" // Scheduled - Blue
      : appointment.flag === "M"
      ? "bg-[#FFF3E0] text-[#F57C00] border border-[#F57C00]" // Missed - Orange
      : appointment.flag === "R"
      ? "bg-[#F3E5F5] text-[#7B1FA2] border border-[#7B1FA2]" // Rescheduled - Purple
      : appointment.flag === "D"
      ? "bg-[#E8F5E8] text-[#2E7D32] border border-[#2E7D32]" // Completed - Emerald/Green
      : appointment.flag === "C"
      ? "bg-[#FFEBEE] text-[#D32F2F] border border-[#D32F2F]" // Cancelled - Red
      : "bg-gray-200 text-gray-600 border border-gray-400"
  }`}
>
  {appointment.flag === "A"
    ? "Confirmed"
    : appointment.flag === "M"
    ? "Missed"
    : appointment.flag === "D"
    ? "Completed"
    : appointment.flag === "S"
    ? "Scheduled"
    : appointment.flag === "R"
    ? "Rescheduled"
    : appointment.flag === "C"
    ? "Cancelled"
    : appointment.flag}
</button>

                               <p className="text-[12px] mt-2">
                              {appointment.formattedTime}
                            </p>
                          </div>

                          {/* Right Section*/}
                          <div className="flex flex-col gap-2 justify-center ">
                            {/* <button
                              className="text-[14px] w-[80%] text-white bg-[#009A85]  h-8 px-2  rounded-lg shadow-lg shadow-md shadow-gray-300"
                            
                               onClick={()=>{startMeeting(appointment.meetLink)}}
                            >
                             Start Video Call
                            </button> */}
                         
                         

                            <button
                              className="text-[14px] w-[80%] text-white bg-[#009A85] h-6 px-2 rounded-lg shadow-lg shadow-md shadow-gray-300"
                              onClick={() => {
                                setShowProfilePopup(true);
                                setPatientId(appointment.patientId);
                              }}
                            >
                              Profile
                            </button>
                          </div>
                        </div>
                      ))}
                    </>
                  )}
                  {/* <div className="flex justify-end mt-2"><p className="text-[14px] text-[#2F80ED] mr-2">More Appointments</p></div> */}
                </div>

                {/* chart div */}
                <div className="sticky top-[200px] bg-white  w-full sm:w-2/5 pt-5 ">
                  <p className=" text-center text-[#606060] text-xl font-semibold  w-full">
                    Statistics
                  </p>
                  <div className="flex flex justify-center mt-3">
                    <DoctorProfileChart
                      pending={pendingAppointments.length}
                      active={activeAppointments.length}
                      scheduled={scheduleAppointments.length}
                      cancelled={cancelledAppointments.length}
                      Completed={completedAppointments.length}
                      Missed={missedAppointments.length}
                    />
                  </div>
                </div>
              </div>
          <HomePageDoctorCalender  upcommingFromTodayAppointments={upcommingFromTodayAppointments} />
            </div>
          )}
          
          {activePage === "Scheduled" && (
            <AppointmentList
              title="Scheduled Appointments"
              description="Manage and review upcoming appointments, patient details, and consultation actions."
              appointments={currentAppointments}
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={setCurrentPage}
              itemsPerPage={itemsPerPage}
              onItemsPerPageChange={setItemsPerPage}
              //   onProfileClick={(id) => {
              //   setPatientId(id);
              //   setShowProfilePopup(true);
              // }}
            />
          )}
         {activePage === "Active" && (
  <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-16">
    <div className="w-full space-y-6">
      {/* Enhanced Header Section */}
        <div className="relative overflow-hidden bg-gradient-to-r from-[#009A85]/10 via-[#009A85]/5 to-transparent rounded-2xl border border-[#009A85]/20 p-2 backdrop-blur-sm">
       <div className="relative z-10">
          <div className="flex items-center gap-4 ">
            <div className="w-1.5 h-8 bg-gradient-to-b from-[#009A85] to-[#007f6d] rounded-full"></div>
            <div className="flex-1">
                <h1 className="text-md sm:text-lg font-bold text-gray-900 mb-1">
                Active Appointments
              </h1>
              <div className="flex items-center gap-3">
                <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-semibold bg-green-100 text-green-700 border border-green-200">
                  <div className="w-2 h-2 bg-green-500 rounded-full mr-2 animate-pulse"></div>
                  {currentAppointments.length} active
                </span>
        
              </div>
            </div>
          </div>
          {/* <p className="text-gray-600 leading-relaxed max-w-3xl">
            List of current scheduled appointments ready for video consultation.
          </p> */}
        </div>
        {/* Decorative Elements */}
        <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-green-500/20 to-transparent rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-8 w-24 h-24 bg-gradient-to-tl from-[#009A85]/20 to-transparent rounded-full blur-2xl"></div>
      </div>

      <div className="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden">
        {/* Desktop Table Header */}
        <div className="hidden sm:block bg-gradient-to-r from-gray-50 to-gray-100 border-b border-gray-200">
          <div className="grid grid-cols-5 lg:grid-cols-6 gap-4 px-6 py-4">
            <div className="col-span-1 lg:col-span-2">
              <div className="flex items-center gap-2">
                <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
                <span className="text-sm font-semibold text-gray-700">Patient Information</span>
              </div>
            </div>
            <div className="hidden lg:block">
              <div className="flex items-center gap-2">
                <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 002 2z" />
                </svg>
                <span className="text-sm font-semibold text-gray-700">Age</span>
              </div>
            </div>
            <div className="col-span-1">
              <div className="flex items-center gap-2">
                <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <span className="text-sm font-semibold text-gray-700">Date & Time</span>
              </div>
            </div>
            {/* <div className="hidden sm:block">
              <div className="flex items-center gap-2">
                <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
                </svg>
                <span className="text-sm font-semibold text-gray-700">Consultation Type</span>
              </div>
            </div> */}
            <div className="col-span-2 lg:col-span-1 text-center">
              <span className="text-sm font-semibold text-gray-700">Actions</span>
            </div>
          </div>
        </div>

        {/* Appointments List */}
        <div className="max-h-[calc(100vh-300px)] overflow-y-auto custom-scrollbar">
          {currentAppointments.length === 0 ? (
            <div className="p-8">
              <div className="flex flex-col items-center justify-center py-16 px-6 bg-gradient-to-br from-gray-50 to-gray-100 rounded-2xl border-2 border-dashed border-gray-300">
                <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center shadow-lg mb-6">
                  <svg className="w-10 h-10 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 002 2v8a2 2 0 002 2z" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-gray-700 mb-3">
                  No active appointments found
                </h3>
                <p className="text-gray-500 text-center max-w-md leading-relaxed">
                  When patients are ready for consultation, they will appear here for video calls.
                </p>
              </div>
            </div>
          ) : (
            <div className="divide-y divide-gray-100">
              {currentAppointments.map((appointment: any, index: number) => (
                <div
                  key={`${appointment.appointmentId}-${index}`}
                  className="group hover:bg-gradient-to-r hover:from-green-50 hover:to-transparent transition-all duration-300 ease-out"
                >
                  {/* Mobile Layout */}
                  <div className="sm:hidden p-4 space-y-4">
                    <div className="flex items-start gap-4">
                      <div className="relative">
                        <div className="w-10 h-10 bg-gradient-to-br from-[#009A85] to-[#007f6d] rounded-full flex items-center justify-center text-white font-bold text-sm shadow-lg flex-shrink-0 group-hover:scale-105 transition-transform duration-200">
  {(() => {
    const [firstName, middleName] = appointment.patientName?.split(" ") || [];
    const firstInitial = firstName?.charAt(0)?.toUpperCase() || "";
    const middleInitial = middleName?.charAt(0)?.toUpperCase() || "";
    return firstInitial + middleInitial || "P";
  })()}
</div>
                        <div className="absolute -top-1 -right-1 w-4 h-4 bg-green-500 rounded-full border-2 border-white animate-pulse"></div>
                      </div>
                      <div className="flex-1 min-w-0">
                        <h3 className="font-bold text-gray-900 text-lg leading-tight">
                          {appointment.patientName}
                        </h3>
                        <p className="text-sm text-gray-500 mt-1">
                          ID: {appointment.appointmentId} • {appointment.age} years
                        </p>
                        <div className="flex items-center gap-2 mt-2 text-sm text-gray-600">
                          <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                          </svg>
                          <span className="font-medium">
                            {appointment.formattedTime}, {appointment.formattedDate}
                          </span>
                        </div>
                        {/* <div className="mt-3">
                          <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-semibold bg-green-100 text-green-700 border border-green-200">
                            <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 002 2v8a2 2 0 002 2z" />
                            </svg>
                            Video Consultation
                          </span>
                        </div> */}
                      </div>
                    </div>
                    <div className="space-y-3">
                      
                      <button
                        onClick={() => {
                                    startMeeting(appointment.meetLink,appointment.meetId,appointment.meetPassword,appointment.patientId,appointment.appointmentId);
                                  
                                  }}
                        className="w-full bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white py-2 px-6 rounded-xl font-semibold text-sm transition-all duration-200 shadow-lg hover:shadow-xl hover:-translate-y-0.5 active:scale-95 flex items-center justify-center gap-2"
                      >
                   
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 002 2v8a2 2 0 002 2z" />
                        </svg>
                        Start Call
                      </button>
                      <button
                        onClick={() => {
                          setShowProfilePopup(true);
                          setPatientId(appointment.patientId);
                        }}
                        className="w-full bg-gradient-to-r from-[#184A84] to-[#0f3a6b] hover:from-[#0f3a6b] hover:to-[#184A84] text-white py-2.5 px-6 rounded-xl font-semibold text-sm transition-all duration-200 shadow-md hover:shadow-lg hover:-translate-y-0.5 active:scale-95"
                      >
                        View Profile
                      </button>
                    </div>
                  </div>

                  {/* Desktop Layout */}
                  <div className="hidden sm:block">
                    <div className="grid grid-cols-5 lg:grid-cols-6 gap-4 px-6 py-5 items-center">
                      {/* Patient Info */}
                      <div className="col-span-1 lg:col-span-2">
                        <div className="flex items-center gap-4">
                          <div className="relative">
                            <div className="w-10 h-10 bg-gradient-to-br from-[#009A85] to-[#007f6d] rounded-full flex items-center justify-center text-white font-bold text-sm shadow-lg flex-shrink-0 group-hover:scale-105 transition-transform duration-200">
  {(() => {
    const [firstName, middleName] = appointment.patientName?.split(" ") || [];
    const firstInitial = firstName?.charAt(0)?.toUpperCase() || "";
    const middleInitial = middleName?.charAt(0)?.toUpperCase() || "";
    return firstInitial + middleInitial || "P";
  })()}
</div>
                            <div className="absolute -top-1 -right-1 w-4 h-4 bg-green-500 rounded-full border-2 border-white animate-pulse"></div>
                          </div>
                          <div className="min-w-0 flex-1">
                            <h3 className="font-bold text-gray-900 text-base leading-tight truncate">
                              {appointment.patientName}
                            </h3>
                            <p className="text-sm text-gray-500 mt-1">
                              ID: {appointment.appointmentId}
                            </p>
                          </div>
                        </div>
                      </div>

                      {/* Age */}
                      <div className="hidden lg:block">
                        <span className="inline-flex items-center px-3 py-1.5 rounded-full text-sm font-semibold bg-gray-100 text-gray-700 border border-gray-200 group-hover:bg-green-100 group-hover:text-green-700 group-hover:border-green-200 transition-all duration-200">
                          {appointment.age} yrs
                        </span>
                      </div>

                      {/* Date & Time */}
                      <div className="col-span-1">
                        <div className="space-y-1">
                          <div className="flex items-center gap-2">
                            <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 002 2z" />
                            </svg>
                            <span className="text-sm font-semibold text-gray-900">
                              {appointment.formattedDate}
                            </span>
                          </div>
                          <div className="flex items-center gap-2">
                            <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            <span className="text-sm text-gray-600">
                              {appointment.formattedTime}
                            </span>
                          </div>
                        </div>
                      </div>

                      {/* Consultation Type */}
                      {/* <div className="hidden sm:block">
                        <span className="inline-flex items-center gap-2 px-3 py-2 rounded-full text-sm font-semibold bg-green-100 text-green-700 border border-green-200 group-hover:bg-green-200 transition-all duration-200">
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 002 2v8a2 2 0 002 2z" />
                          </svg>
                          Video Consultation
                        </span>
                      </div> */}

                      {/* Actions */}
                      <div className="col-span-2 lg:col-span-1">
                        <div className="flex flex-col gap-2">
                           <button
                        onClick={() => {
                                    startMeeting(appointment.meetLink,appointment.meetId,appointment.meetPassword,appointment.patientId,appointment.appointmentId);
                                  
                                  }}
                        className="w-full bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white py-2 px-6 rounded-xl font-semibold text-sm transition-all duration-200 shadow-lg hover:shadow-xl hover:-translate-y-0.5 active:scale-95 flex items-center justify-center gap-2"
                      >
                      
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 002 2v8a2 2 0 002 2z" />
                        </svg>
                        Start Call
                      </button>
                      
                          <button
                            onClick={() => {
                              setShowProfilePopup(true);
                              setPatientId(appointment.patientId);
                            }}
                            className="bg-gradient-to-r from-[#184A84] to-[#0f3a6b] hover:from-[#0f3a6b] hover:to-[#184A84] text-white px-4 py-1.5 rounded-lg font-semibold text-xs transition-all duration-200 shadow-md hover:shadow-lg hover:-translate-y-0.5 active:scale-95"
                          >
                            Profile
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

    
     
    </div>
  </div>
)}
          {activePage === "Confirmed" && (
            <AppointmentList
              title="Confirmed Appointments"
              description=" Manage and review upcoming appointments, patient details, and
          consultation actions."
              appointments={pendingAppointments}
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={setCurrentPage}
              itemsPerPage={itemsPerPage}
              onItemsPerPageChange={setItemsPerPage}
              // onShowProfile={(patientId) => {
              //   setPatientId(patientId);
              //   setShowProfilePopup(true);
              // }}
              // currentPage={currentPage}
              // totalPages={totalPages}
              // onPageChange={setCurrentPage}
            />
          )}
          {activePage === "Rescheduled" && (
            <AppointmentList
              title="Rescheduled Appointments"
              description="Manage and review upcoming appointments, patient details, and consultation actions."
              appointments={currentAppointments}
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={setCurrentPage}
              itemsPerPage={itemsPerPage}
              onItemsPerPageChange={setItemsPerPage}
              // onProfileClick={(id) => {
              //   setPatientId(id);
              //   setShowProfilePopup(true);
              // }}
            />
          )}
          {activePage === "Completed" && (
            <AppointmentList
              title="Completed Appointments"
              description="Manage and review completed appointments, patient details, and consultation summaries."
              appointments={completedAppointments}
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={setCurrentPage}
              itemsPerPage={itemsPerPage}
              onItemsPerPageChange={setItemsPerPage}
              // onProfileClick={(id) => {
              //   setPatientId(id);
              //   setShowProfilePopup(true);
              // }}
            />
          )}
          {activePage === "Cancelled" && (
            <AppointmentList
              title="Cancelled Appointments"
              description="Manage and review upcoming appointments, patient details, and consultation actions."
              appointments={currentAppointments}
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={setCurrentPage}
              itemsPerPage={itemsPerPage}
              onItemsPerPageChange={setItemsPerPage}
              // onProfileClick={(id) => {
              //   setPatientId(id);
              //   setShowProfilePopup(true);
              // }}
            />
          )}
          {activePage === "Missed" && (
            <AppointmentList
              title="Missed Appointments"
              description="Manage and review upcoming appointments, patient details, and consultation actions."
              appointments={currentAppointments}
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={setCurrentPage}
              itemsPerPage={itemsPerPage}
              onItemsPerPageChange={setItemsPerPage}
              // onProfileClick={(id) => {
              //   setPatientId(id);
              //   setShowProfilePopup(true);
              // }}
            />
          )}
        </div>
      </div>
    </div>
  );
};
export default DoctorDashboard;
